import type { Merge } from 'powership';
import React, { type JSX, useState } from 'react';

interface HeaderProps {
  // Add any props if needed in the future
}

type LinkValue = Merge<JSX.IntrinsicElements['a'], { key: string }>;

const Header: React.FC<HeaderProps> = () => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const navigationLinks: LinkValue[] = [
    { href: '/', children: 'Início', key: 'inicio' },
    { href: '/o-que-e-noopept', children: 'Sobre', key: 'sobre' },
    { href: '/#noopept-publicacoes', children: 'Artigos', key: 'artigos' },
    {
      href: '/#noopept-perguntas-frequentes',
      children: 'Perguntas Frequentes',
      key: 'faq',
    },
    {
      href: 'https://wa.me/551150398080',
      target: '_blank',
      children: 'Contato',
      key: 'contato',
    },
    {
      href: '/termos',
      children: 'Termos & Política',
      key: 'termos',
    },
  ];

  const [activeLink, setActiveLink] = useState<string>('inicio');

  const handleLinkClick = (id: string): void => {
    setActiveLink(id);
    setIsMenuOpen(false);
  };

  const handleMenuClick = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.stopPropagation();
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header
      className="border-b border-gray-200 sticky top-0 z-[100] shadow"
      style={{ background: 'linear-gradient(180deg, #f6f9fc, #fff)' }}
    >
      <div className="container px-4 mx-auto sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center -m-2 xl:hidden">
            <button
              onClick={handleMenuClick}
              type="button"
              className="inline-flex items-center justify-center p-2 text-gray-400 bg-white rounded-lg hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand"
            >
              <svg
                className="w-6 h-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
          <div className="flex">
            <div className="flex items-center flex-shrink-0">
              <a href={'/'} title={'Noopept.com.br Logo'}>
                <img src="/logo.svg" className="h-8" alt="Noopept Logo" />
              </a>
            </div>
            <div className="hidden sm:-my-px sm:ml-8 xl:flex xl:space-x-10">
              {navigationLinks.map((link) => (
                <a
                  {...link}
                  key={link.key}
                  onClick={() => handleLinkClick(link.key)}
                  className={`link__${link.key} inline-flex items-center px-1 pt-1 text-sm font-medium transition-all duration-200 border-b-2 ${
                    activeLink === link.key
                      ? 'text-brand border-brand'
                      : 'text-gray-500 border-transparent hover:border-gray-300 hover:text-gray-900'
                  }`}
                />
              ))}
            </div>
          </div>

          <div className="flex items-center space-x-4">
            {/*<a*/}
            {/*  href="https://wa.me/551150398080"*/}
            {/*  target="_blank"*/}
            {/*  className="inline-flex items-center px-6 py-3 text-sm font-medium text-brand transition-all duration-300 bg-gradient-to-br rounded-lg hover:bg-gradient-to-br hover:-translate-y-0.5"*/}
            {/*>*/}
            {/*  <svg*/}
            {/*    xmlns="http://www.w3.org/2000/svg"*/}
            {/*    viewBox="0 0 24 24"*/}
            {/*    fill="currentColor"*/}
            {/*    className="size-6 w-5 h-5 mr-2"*/}
            {/*  >*/}
            {/*    <path*/}
            {/*      fillRule="evenodd"*/}
            {/*      d="M7.5 6v.75H5.513c-.96 0-1.764.724-1.865 1.679l-1.263 12A1.875 1.875 0 0 0 4.25 22.5h15.5a1.875 1.875 0 0 0 1.865-2.071l-1.263-12a1.875 1.875 0 0 0-1.865-1.679H16.5V6a4.5 4.5 0 1 0-9 0ZM12 3a3 3 0 0 0-3 3v.75h6V6a3 3 0 0 0-3-3Zm-3 8.25a3 3 0 1 0 6 0v-.75a.75.75 0 0 1 1.5 0v.75a4.5 4.5 0 1 1-9 0v-.75a.75.75 0 0 1 1.5 0v.75Z"*/}
            {/*      clipRule="evenodd"*/}
            {/*    />*/}
            {/*  </svg>*/}
            {/*  Onde comprar?*/}
            {/*</a>*/}
          </div>
        </div>
      </div>
      {/* Menu Mobile */}
      <div className={`xl:hidden ${isMenuOpen ? '' : 'hidden'}`}>
        <div className="px-2 pt-2 pb-3 space-y-1">
          {navigationLinks.map((link) => (
            <a
              {...link}
              key={link.key}
              onClick={() => handleLinkClick(link.key)}
              className={`block px-3 py-2 text-base font-medium rounded-md ${
                activeLink === link.key
                  ? 'text-brand'
                  : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'
              }`}
            />
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;
